import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ColumnConfig } from '../models/column-config.model';
import { process } from "@progress/kendo-data-query";
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
@Component({
  selector: 'app-select-tcc-popup',
  templateUrl: './select-tcc-popup.component.html',
  styleUrl: './select-tcc-popup.component.scss'
})
export class SelectTccPopupComponent {
  dataList!: GridDataResult;
  skip = 0;
  pageSize = 10;

  ogDataList: any[] = [];
  placeHolderValue = "Search";

  @Input() set setGridData(data: GridDataResult) {
    if (data?.data?.length > 0) {
      this.dataList = data;
    }else{
      this.dataList = { data: [], total: 0 };
    }
  }

  searchString = "";

  @Input() set setPlaceholder(placeHolder: string) {
    this.placeHolderValue = placeHolder;
  }

  public columnConfig: ColumnConfig[] = [
    //For Example
    // { field: 'type', title: 'Service Type', width: 120 },
    // { field: 'description', title: 'Description', width: 280 },
  ];

  @Input() set setColumnConfig(colList: ColumnConfig[]) {
    if (colList?.length > 0) {
      this.columnConfig = colList;
    }
  }

  @Output() sendDataItem = new EventEmitter<any>();

  @Output() pageChanged = new EventEmitter<any>();

  buttonName = "Select Task";
  isSearchOn = true;
  @Input() set setIsPopUpHasSearch(isPopUpHasSearch: boolean) {
    this.isSearchOn = isPopUpHasSearch;
  }

  @Input() set setButtonName(buttonName: string) {
    this.buttonName = buttonName;
  }

  buttonClicked(dataItem: any) {
    this.sendDataItem.emit(dataItem);
  }

  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip;
    this.pageChanged.emit({
      skip: this.skip,
      pageSize: this.pageSize,
      searchText: this.searchString
    });
  }

  popupEquipmentSearch() {
    this.skip = 0;
    this.pageChanged.emit({
      skip: this.skip,
      pageSize: this.pageSize,
      searchText: this.searchString
    });
  };

  resetData(){
    this.skip = 0;
    this.searchString = "";

    this.pageChanged.emit({
      skip: this.skip,
      pageSize: this.pageSize,
      searchText: this.searchString
    });
  }
}


